import React from 'react';
import axios from 'axios';
import Breadcrumb from  '../../../components/Layout/Breadcrumb';
import SystemEmailTips from './SystemEmailTips';
import { connect } from 'react-redux';
import { MdEmail } from 'react-icons/md';
import { Button } from 'react-bootstrap';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {
	Row,
	Col,
	Card,
	CardBody,
	Form,
	FormGroup,
	Input,
	Label,
	Alert
} from 'reactstrap';

class SystemEmailCreateComponent extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			error: false,
			messageError: '',
			isNotification: '',
			textNotification: '',
			isSpinner: false,
			emailId: 0,
			title: '',
			subject: '',
			content: '',
			service: '',
			service_type: [],
		}
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		this.getSystemEmailService();
		this.setState({
			isNotification: this.props.isNotification,
			textNotification: this.props.textNotification,
		})
		if ( this.props.isNotification ) {
			this.props.notification({
				isNotification: false,
				textNotification: ''
			});
		}
	}

	getSystemEmailService = () => {
		this.setState({
			isLoading: true
		});

		let dataAuth = {
			username: process.env.REACT_APP_CLIENT_ID,
			password: process.env.REACT_APP_CLIENT_PASSWD,
			token: process.env.REACT_APP_KEY,
		};

		let config = {
		  	headers: {
				'Content-Type': 'application/json',
				'Authorization' : this.props.token,
				'dataAgency' : JSON.stringify(dataAuth)
			}
		}
		axios.get( process.env.REACT_APP_API_URL + '/api/admin/email/system-email/get-service', config)
		.then( (ref) => {
			// console.log(ref.data);
			if ( ref.data.error === 0 ) {
				this.setState({
					service_type: ref.data.content.service_type,
					isLoading: false,
					error: false,
					messageError: '',
				})
			} else {
				if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
					this.props.logOut();
				} else {
					this.setState({
						error: true,
						messageError: ref.data.message,
						isLoading: false,
					})
				}
			}
		})
		.catch( (error) => {
			console.log(error);
			this.setState({
				isLoading: false
			});
			this.setState({
				error: true,
				messageError: 'Lấy dữ liệu thất bại',
			})
		})
	}

	checkNotification = () => {
		if ( this.state.isNotification ) {
			return (
				<Alert color="success">{ this.state.textNotification } </Alert>
				);
		}
	}

	change = (e) => {
		this.setState({
			[e.target.name]: e.target.value
		})
	}

	createSystemEmail = (e) => {
		e.preventDefault();

		this.setState({
			isLoading: true,
			isNotification: '',
			textNotification: '',
		});

		let formData = new FormData();
		let data = { title: this.state.title, subject: this.state.subject, content: this.state.content, service: this.state.service };
		for (let [key, val] of Object.entries(data)) {
		  formData.append(key, val);
		}

		let dataAuth = {
			username: process.env.REACT_APP_CLIENT_ID,
			password: process.env.REACT_APP_CLIENT_PASSWD,
			token: process.env.REACT_APP_KEY,
		};

		let config = {
		  	headers: {
				'Content-Type': 'application/json',
				'Authorization' : this.props.token,
				'dataAgency' : JSON.stringify(dataAuth)
			}
		}

		axios.post( process.env.REACT_APP_API_URL + '/api/admin/email/system-email/create', formData, config)
		.then( (ref) => {
			// console.log(ref.data);
			if ( ref.data.error === 0 ) {
				this.setState({
					isNotification: true,
					textNotification: ref.data.message,
					emailId: ref.data.content.email.id,
					isLoading: false,
					error: false,
					messageError: '',
				});
				this.redirectFinish(this.state.textNotification, this.state.emailId);
			} else {
				if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
					this.props.logOut();
				} else {
					this.setState({
						isLoading: false,
						error: true,
						messageError: ref.data.message,
					})
				}
			}
		})
		.catch( (error) => {
			console.log(error);
			this.setState({
				isLoading: false
			});
			this.setState({
				error: true,
				messageError: 'Lấy dữ liệu thất bại',
			})
		})
	}

    redirectFinish = (message, emailId) => {
        this.props.notification({
            isNotification: true,
            textNotification: message
        });
        this.props.shouldRedirect(emailId);
    }

	render() {
		return (
			<>
				<Breadcrumb title={"Edit System Email"} page={"Edit System Email"} icon={<MdEmail className="breadcrumb-icon" />} />
				<Row style={{ marginTop: 20 }}>
					<Col sm={12}>
						{ this.state.error ? (<Alert color="danger"><div className='text-center'>{ this.state.messageError }</div></Alert>) : (<></>)}
						{this.checkNotification()}
					</Col>
				</Row>
				<Form onSubmit={ this.createSystemEmail }>
					<Row>
						<Col xl={8} lg={7} md={12}>
							<Card>
								<CardBody>
										<FormGroup>
											<Label for="title">Tên email</Label>
											<Input
												type="text"
												id="title"
												name="title"
												placeholder="Nhập tiêu đề"
												defaultValue={this.state.title}
												onChange={  this.change }
											/>
										</FormGroup>
										<FormGroup>
											<Label for="subject">Tiêu đề email</Label>
											<Input
												type="text"
												id="subject"
												name="subject"
												placeholder="Subject"
												defaultValue={this.state.subject}
												onChange={ this.change }
											/>
										</FormGroup>
										
										<FormGroup>
						                  	<Label for="content">Nội dung email</Label>
						                  	<CKEditor
						                  		id="content"
						                  		name="content"
                                                config={{
                                                    placeholder: "Nhập nội dung email ..."
                                                }}
                                                editor={ ClassicEditor }
							                    data={ this.state.content }
							                    onChange={ ( event, editor ) => {
							                        const data = editor.getData();
							                        this.setState({
							                        	content: data
							                        })
							                    } }
							                />
						                </FormGroup>
								</CardBody>
							</Card>
						</Col>
						<Col xl={4} lg={5} sm={12}>
							<Card>
								<CardBody>
										<FormGroup>
											<Label for="title">Loại email</Label>
											<Input 
												className="mb-2" 
												type="select"
												name="service"
												value={ this.state.service }
												onChange={ this.change }
											>
												<option value={''} disabled>Chọn loại email</option>
							                  	{
							                  		this.state.service_type ? 
							                    	Object.entries(this.state.service_type)
												  	.map(
												   		([key, type]) => (<option key={key} value={key}>{type}</option>)
												  	) :
												  	<></>
												}
							                </Input>
										</FormGroup>
										<Button type="submit">Tạo email</Button>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</Form>
				<SystemEmailTips />
			</>	
		)
	}
}

const mapStateToProps = (state) => {
	return {
		token: state.login.token,
		isNotification: state.adminMain.isNotification,
		textNotification: state.adminMain.textNotification,
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		logOut: () => {
			dispatch(({ type : 'logOut', page: 'AdminSystemEmailCreate' }))
		},
		notification: (item) => {
			dispatch(({ type : 'notification', item }))
		},
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(SystemEmailCreateComponent);